<template>
	<div class="feedback-list" ref="list">
		<div class="feedback-list-item" v-for="(item, i) in list" :key="i" @click="onClickDetail(item)">
			<div class="time">{{item.formattedCreateTime}}</div>
			<div class="status" :style="`color: ${item.statusColor};`">{{item.statusText}}</div>
		</div>
		<div ref="bottom" class="bottom" >
			<VanButton class="btn" @click="onClickAdd">意见反馈</VanButton>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FeedbackList',
	props: {
		list: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	watch: {
		list() {
			this.calcStyle();
		}
	},
	mounted() {
		this.calcStyle();
	},
	methods: {
		calcStyle() {
			const list = this.$refs.list;
			console.error('list', list);
			if (list) {
				const height = list.clientHeight;
				const windowHeight = window.innerHeight;
				if (height > windowHeight) {
					this.$refs.bottom.style.position = 'fixed';
					this.$refs.bottom.style.bottom = '50px';
					this.$refs.bottom.style.left = 0;
					this.$refs.bottom.style.right = 0;
				} else {
					this.$refs.bottom.style.position = 'relative';
				}
			}
		},
		onClickDetail(record) {
			this.$emit('detail', record);
		},
		onClickAdd() {
			this.$emit('add');
		}
	}
};
</script>

<style scoped lang="scss">
	.feedback-list {
		background: #F3F4F5;
		padding: 10px 0;
	}
	.feedback-list-item {
		margin: 0 10px;
		height: 56px;
		background: #FFFFFF;
		border-radius: 12px;
		padding: 0 14px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.time {
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 16px;
		color: #000000;
		line-height: 22px;
	}
	.status {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
		line-height: 22px;
	}
	.bottom {
		padding: 0 14px;
	}
	.btn {
		width: 100%;
		height: 48px;
		background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
		border-radius: 25px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 25px;
	}
</style>
